import moment, { Moment } from 'moment'
import { isNil } from 'lodash'
import 'moment/locale/id'

moment.locale('id')

const formatDate = (date: string | Date) => {
  return moment(date).format('DD MMMM YYYY')
}

const formatDateTime = (date: string | Date) => {
  return moment(date).format('DD MMMM YYYY HH:mm:ss')
}

const formatDateDay = (date: string | Date) => {
  return moment(date).format('dddd, DD MMMM YYYY')
}

function parse(date: string | Moment | null | undefined) {
  if (isNil(date)) {
    return date
  }
  return moment.isMoment(date) ? date : moment(date)
}

const formatMonthYear = (date: string | Date) => {
  return moment(date).format('MMMM YYYY')
}

export default {
  formatDate,
  formatDateTime,
  parse,
  formatDateDay,
  formatMonthYear
}
